import { render, staticRenderFns } from "./BnftSrvRcrd.vue?vue&type=template&id=2ab43d32&"
import script from "./BnftSrvRcrd.vue?vue&type=script&lang=js&"
export * from "./BnftSrvRcrd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports